import {METRIC as CONV_METRIC} from '@stripe-internal/conversations-client';

const PREFIX = 'conversations_client.twilio_client_v2';

export const METRIC = {
  ...CONV_METRIC,
  service_init_error: `${PREFIX}.service_init.error`,
  service_init_duration: `${PREFIX}.service_init.duration`,
  stp_error: `${PREFIX}.stripethirdparty.error`,
  connection_state_denied: `${PREFIX}.connection_state_denied`,
};
